export default "__VITE_ASSET__DbNwHVp3__"